import * as React from 'react'

function IconPrev(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={69}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M60.055 1.636l-23.69 13.672c-3.706 2.14-3.706 7.489 0 9.63l23.69 13.678c3.706 2.14 8.343-.537 8.343-4.818V6.448c-.007-4.282-4.637-6.953-8.343-4.812z"
        fill="#E84E25"
      />
      <path
        d="M31.297 1.636L7.607 15.308c-3.705 2.14-3.705 7.489 0 9.63l23.69 13.678c3.706 2.14 8.343-.537 8.343-4.818V6.448c0-4.282-4.637-6.953-8.343-4.812z"
        fill="#E84E25"
      />
      <path
        d="M5.439 40a5.439 5.439 0 005.439-5.439V5.439A5.439 5.439 0 100 5.439v29.122C0 37.561 2.438 40 5.439 40z"
        fill="#E84E25"
      />
    </svg>
  )
}

export default IconPrev
